import { observer } from 'mobx-react';
import React from 'react';
import 'styles/app.scss';
import { ApolloProvider } from '@apollo/react-hooks';
import { MuiThemeProvider } from '@material-ui/core/styles';
import useInitApollo from 'hooks/useInitApollo';
import { ToastContainer } from 'react-toastify';
import { Switch, Route } from 'react-router-dom';
import { useStores } from 'hooks';
import { HelmetProvider } from 'react-helmet-async';

import MainLayoutRouter from 'pages/MainLayoutRouter.jsx';
import AuthLayoutRouter from 'pages/AuthLayoutRouter.jsx';

import defaultTheme from './theme/defaultTheme';
import { useViewerPermissions } from './hooks';
import 'react-toastify/dist/ReactToastify.css';

const App = observer(() => {
  const { authStore } = useStores();

  const client = useInitApollo({
    onUnauthorizedError: () => {
      console.log('clearing token in local');
      authStore.logoutAll();
    },
    token: authStore.currentIdentity,
  });

  const [isCompleted, viewerLoading, permissionsLoading] = useViewerPermissions({
    client,
    onGetViewerError: (err) => {
      console.log(err);
    },
    onGetPermissionError: (err) => {
      console.log(err);
    },
  });

  if (!isCompleted || viewerLoading || permissionsLoading) return null;

  return (
    <ApolloProvider client={client}>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        pauseOnHover
      />
      <HelmetProvider>
        <div className="App">
          <MuiThemeProvider theme={defaultTheme}>
            <Switch>
              <Route
                name="ResetPassword"
                path="/reset-password/:token"
                component={AuthLayoutRouter}
              />
              <Route
                name="AccountEnroll"
                path="/account/enroll/:token"
                component={AuthLayoutRouter}
              />
              <Route name="Login" path="/login" component={AuthLayoutRouter} />
              <Route name="Portal" path="/" component={MainLayoutRouter} />
            </Switch>
          </MuiThemeProvider>
        </div>
      </HelmetProvider>
    </ApolloProvider>
  );
});

export default App;
